import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  totalItems: number
  'data-cy-state': string
}

export function MoreIndicatorDesktop(props: Props) {
  const t = useTranslations<'molecules-account-Minicart'>()
  return (
    <Wrapper
      className="MoreIndicatorDesktop"
      data-cy-state={props['data-cy-state']}
    >
      <div className="floating">
        <span>+{props.totalItems - 3}</span>
      </div>
      <div className="label">
        {props.totalItems - 3} {t('moreindicatordesktop_further_articles')}
      </div>
    </Wrapper>
  )
}

export default MoreIndicatorDesktop

const Wrapper = styled.div`
  display: none;
  @media (min-width: ${theme.ms.MD}px) {
    display: flex;
    gap: ${theme.spacing('m')};
    align-items: center;
    > .floating {
      width: 90px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.25);
        ${theme.ty('rc-base', 'bold')}
      }
    }
    > .label {
      ${theme.ty('r-l', 'bold')};
    }
  }
`
